import React from 'react';

function SignUp() {
	return (
		<div>
			<h1>Sign Up Page</h1>
		</div>
	);
}

export default SignUp;
